// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleSlaManager = {
  id: "sla-manager",
  mrn: "//iam.api.mondoo.app/roles/sla-manager",
  title: "SLA Manager",
  allowedActions,
} as const;

export type RoleSlaManager = typeof roleSlaManager;
